import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';

@Injectable()
export class AuthGuardService {

  constructor(private _login: LoginService, private router: Router) { }

  canActivate(): boolean | Promise<boolean> {
		let token = this._login.getToken();

		if (!token) {
			console.error("User is not authenticated.");
			this.redirectToLoginPage();
			return false;
		}
		else if (this._login.isAuthenticated()) {
			return true;
		}
		else {
    //   this._login.refreshToken();
    //   return true;
         return true;
		}
  }
  
  redirectToLoginPage() {
    this.router.navigate(['/public/login']);
}

}